import { LogLevel } from "@azure/msal-browser";

function getStorageValue(key, item) {
    const saved = localStorage.getItem(key);
    const configObject = JSON.parse(saved);
    const value = configObject ? configObject[item] : null;
    return value;
}

export const msalConfig = {
    auth: {
        redirectUri: window.RUNTIME_CONFIG === null || window.RUNTIME_CONFIG === undefined ? getStorageValue("authConfig", "REACT_APP_REDIRECT_URI") : window.RUNTIME_CONFIG.REACT_APP_REDIRECT_URI,
        clientId: window.RUNTIME_CONFIG === null || window.RUNTIME_CONFIG === undefined ? getStorageValue("authConfig", "REACT_APP_CLIENT_ID") : window.RUNTIME_CONFIG.REACT_APP_CLIENT_ID,
        authority: window.RUNTIME_CONFIG === null || window.RUNTIME_CONFIG === undefined ?  getStorageValue("authConfig", "REACT_APP_AUTHORITY") : window.RUNTIME_CONFIG.REACT_APP_AUTHORITY,
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        //   console.error(message);
                        return;
                    case LogLevel.Info:
                        //   console.info(message);
                        return;
                    case LogLevel.Verbose:
                        //   console.debug(message);
                        return;
                    case LogLevel.Warning:
                        //   console.warn(message);
                        return;
                    default:
                        return; 
                }
            }
        }
    }
};


// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    scopes: ["api://" + (window.RUNTIME_CONFIG === null || window.RUNTIME_CONFIG === undefined ? getStorageValue("authConfig", "REACT_APP_CLIENT_ID") : window.RUNTIME_CONFIG.REACT_APP_CLIENT_ID) + "/User.Read"]
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};